import {useFormikContext} from 'formik';

import {Anchor, Grid, Input, Text} from '@mantine/core';

import {consoleAccountUrl} from '../../config/consoleLinks';
import {User} from '../../types';

// READ-ONLY. Directory shows a person's Account link and Account Admin flag and
// never writes them (FNP-2015). The console's copy edited both here, which made
// it one of several writers of custom:account_id (FNP-1994). Changing either is
// the console's job, so the Account opens there.
//
// Nothing here is a Formik field, and services/userInput.ts leaves both values
// out of every create and update, so a value set elsewhere still never ships.
export const BusinessPanel = () => {
    const {values} = useFormikContext<User>();

    return (
        <Grid p={'sm'} my={'sm'}>
            <Grid.Col span={12}>
                <Input.Wrapper label='Account' description='Change it in the console'>
                    <Text>
                        {values.accountId
                            ? <Anchor
                                href={consoleAccountUrl(values.accountId)}>{values.accountId}</Anchor>
                            : '—'}
                    </Text>
                </Input.Wrapper>
            </Grid.Col>

            <Grid.Col span={12}>
                <Input.Wrapper label='Account Admin' description='Change it in the console'>
                    <Text>{values.accountId ? (values.accountAdmin === 'yes' ? 'Yes' : 'No') : '—'}</Text>
                </Input.Wrapper>
            </Grid.Col>
        </Grid>
    );
};
